import { useContext, useEffect, useRef, useState } from "react";
import { ApplicationState } from "../../services/context/ApplicationStateContext";
import OnlineOrderActions from "../../services/OnlineOrderActions";
import { PopUpContext } from "../../services/context/popupContext";
import useProfile from "../../services/utils/custom hooks/useProfile";
import { useParams } from "react-router-dom";
import useOrderDetail from "../../services/utils/custom hooks/OnlineOrder/useOrderDetail";
import useUpdateOrder from "../../services/utils/custom hooks/OnlineOrder/useUpdateOrder";
import OnlineOrderSelectionFlow from "../../components/popups/onlineOrderSelectionFlowPopup";
import OnlineOrderForm from "../../components/global/forms/OnlineOrderForm";
import OrderLoadingIndicator from "../../components/global/LoadingIndicators/OnlineOrder/OrderLoadingIndicator";
import usePathLabs from "../../services/utils/custom hooks/usePathLabs";
import { OrderStepActions } from "../../services/reducers/OrderStepsReducer";
import { OrderStepsContext } from "../../services/context/OrderStepsContext";
import { useOktaAuth } from "@okta/okta-react";

function UpdateOrderPage(): JSX.Element {
  let { id } = useParams<{ id: string }>();
  const { data, isLoading, isFetching } = useOrderDetail(id);
  const formRef = useRef<any>();
  const profile = useProfile();
  const {
    state: { selectedOrganization, selectedPhysician, selectedPhysicianData, selectedPathLab },
  } = useContext(ApplicationState);
  const { setVisible, setPopUp } = useContext(PopUpContext);
  const { mutate, isPending } = useUpdateOrder(id);
  const { data: pathLabs, isLoading: fetchingPathLabs } = usePathLabs();
  const { dispatch } = useContext(OrderStepsContext);
  const { authState } = useOktaAuth();
  const [preventDiscardPopup, setPreventDiscardPopup] =
    useState<boolean>(false);

  const roles = profile?.data?.user?.roles ?? [];

  useEffect(() => {
    if (!isLoading && !!data?.data) {
      const orderActions = new OnlineOrderActions(
        selectedOrganization,
        selectedPhysician,
        selectedPhysicianData,
        roles,
        profile?.data?.user?.id ?? "",
        selectedPathLab,
        data?.data,
        authState?.accessToken?.accessToken
      );

      orderActions.allowedToUpdateOrder().then((res) => {
        if (!res) {
          setVisible(true);
          setPopUp(<OnlineOrderSelectionFlow orderActions={orderActions} />);
          setPreventDiscardPopup(true);
        } else {
          setPreventDiscardPopup(false);
          if (roles.includes("Collaborative Order Agreement")) {
            dispatch({
              type: OrderStepActions.DISABLE_FIELD,
              payload: "laboratoryInfo.labortaryName",
            });
          }
        }
      });
    }
  }, [selectedOrganization, selectedPhysician, selectedPathLab, isFetching]);

  // Reset order steps when component unmounts (user exits update order page)
  useEffect(() => {
    return () => {
      dispatch({
        type: OrderStepActions.RESET_ORDER_STEPS,
        payload: "",
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isFetching || !!data === false) return <OrderLoadingIndicator />;

  return (
    <OnlineOrderForm
      preventDiscardPopup={preventDiscardPopup}
      setPreventDiscardPopup={setPreventDiscardPopup}
      ref={formRef}
      initialValues={{ ...data?.data }}
      isPending={isPending}
      mutate={mutate}
      isUpdate
      shouldValidate
    />
  );
}

export default UpdateOrderPage;
